import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../context/LocaleContext';
import './Checkout.css';

const CheckoutSuccess = () => {
  const { t } = useTranslation();
  const { localePath } = useLocale();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');
  const isServiceOrder = searchParams.get('type') === 'service';
  const servicePaymentResult = searchParams.get('payment');

  return (
    <div className="checkout-page checkout-page--success">
      <div className="checkout-wrap">
        <div className="checkout-success-card">
          <div className="checkout-success-check">
            <svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="26" cy="26" r="24" stroke="currentColor" strokeWidth="2" fill="none" className="checkout-success-circle" />
              <path d="M14 26l8 8 16-16" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="checkout-success-path" />
            </svg>
          </div>
          <h1>{t('checkout.success')}</h1>
          <p>
            {isServiceOrder
              ? servicePaymentResult === 'partial'
                ? t('checkout.servicePartial')
                : t('checkout.serviceSuccess')
              : t('checkout.productSuccess')}
          </p>
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap', marginTop: '1rem' }}>
            <Link to={localePath(isServiceOrder ? '/services' : '/products')} className="checkout-btn-primary">{isServiceOrder ? t('checkout.servicesBack') : t('checkout.storeBack')}</Link>
            {orderId && (
              <Link to={localePath(isServiceOrder ? `/user-panel/service-orders/${orderId}` : '/user-panel?section=orders')} className="checkout-btn-primary" style={{ background: '#64748b' }}>{isServiceOrder ? t('checkout.projectView') : t('checkout.productView')}</Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccess;
